import { Button, Paper, Stack, Typography, useTheme } from '@mui/material';
import { takeFromStart } from '@weft/utils';
import { ColorDot } from 'apps/app/src/components/design/ColorDot';
import { withSuspenseBoundary } from 'apps/app/src/components/utility/SuspenseBoundary';
import { useGetCustomerCommitmentUsage } from 'apps/app/src/hooks/requests/use-get-customer-commitment-usage';
import dayjs from 'dayjs';
import { NavLink } from 'react-router-dom';
import { DataDashboardLoadingSkeleton } from '../DataDashboardLoadingSkeleton';
import { CustomerCommitmentUsageChart } from './customer-commitment-usage-chart';

const DEFAULT_TABLE_ROW_COUNT = 5;

const CustomerCommitmentUsageSection: React.FC = () => {
  const vyTheme = useTheme();
  const { data: { customerCommitmentUsage: customerCommitmentUsageResponse } } = useGetCustomerCommitmentUsage();
  const customerCommitmentUsage = takeFromStart(customerCommitmentUsageResponse, DEFAULT_TABLE_ROW_COUNT);
  const year = dayjs().year();

  return (
    <Paper
      variant='outlined' 
      sx={(theme) => ({
        boxShadow: theme.shadows[1],
        padding: 3,
      })}
    >
      <Stack
        direction="row"
        justifyItems="center"
      >
        <Typography variant='h6'>Usage vs. Commitment</Typography>
        <Button
          component={NavLink}
          to="/reports/commitment-usage"
          sx={{ marginLeft: 'auto' }}
          variant='outlined'
          size='small'
        >
          See Report
        </Button>
      </Stack>
      <Typography
        variant='body2'
        color={theme => theme.palette.text.secondary}
      >
        {`YTD ${year}`}
      </Typography>
      <Stack
        alignItems="flex-end"
        direction="column"
      >
        <Stack
          gap={1}
          direction="row"
          alignItems="center"
        >
          <ColorDot
            marginLeft={2}
            color="#0D1B2714"
          />
          <Typography
            variant='body2'
            color={theme => theme.palette.text.secondary}
          >
            Commitment
          </Typography>
          <ColorDot
            marginLeft={2}
            color="#0D1B274D"
          />
          <Typography
            variant='body2'
            color={theme => theme.palette.text.secondary}
          >
            Usage
          </Typography>
          <ColorDot
            marginLeft={2}
            color={vyTheme.palette.error.light}
          />
          <Typography
            variant='body2'
            color={theme => theme.palette.text.secondary}
          >
            Overage
          </Typography>
        </Stack>
        <CustomerCommitmentUsageChart customersCommitmentUsage={customerCommitmentUsage} />
      </Stack>
    </Paper>
  );
};

const CustomerCommitmentUsageSectionWithSuspense = withSuspenseBoundary(CustomerCommitmentUsageSection, { suspenseProps: { fallback: <DataDashboardLoadingSkeleton/> } });

export { CustomerCommitmentUsageSectionWithSuspense as CustomerCommitmentUsageSection };